import { graphql } from 'gql';

export const uerSetActKC2AcceptedCostGql = graphql(`
    mutation uerSetActKC2AcceptedCost($actKC2Id: Long!, $workOrderPriceId: Long!, $cost: Decimal!) {
        uerSetActKC2AcceptedCost(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId, cost: $cost) {
            actionRequired
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const uerSetActKC2PlanCostGql = graphql(`
    mutation uerSetActKC2PlanCost($actKC2Id: Long!, $workOrderPriceId: Long!, $cost: Decimal!) {
        uerSetActKC2PlanCost(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId, cost: $cost) {
            actionRequired
            buttonText
            code
            data
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);
